export interface momPanelInterface {
    sno : number;
    title : string;
    editorContent : string;
}

export const panelList : momPanelInterface[] = [
    {
        sno : 1,
        title : "Untitle",
        editorContent : "Enter text..."
    }
]